//  全部字典 请不要修改顺序
export const ALL_SAMPLE_TYPES = [
  { label: "组织", value: "1", elTagType: "primary" },
  { label: "核酸", value: "2", elTagType: "primary" },
  { label: "文库", value: "3", elTagType: "primary" },
  { label: "单细胞(组织)", value: "4", elTagType: "primary" },
  { label: "子文库", value: "5", elTagType: "primary" },
  { label: "交联产物样本", value: "6", elTagType: "primary" },
  { label: "提取产物样本", value: "7", elTagType: "primary" },
  { label: "建库产物样本", value: "8", elTagType: "primary" },
  { label: "单细胞|空间转录组(cDNA)", value: "10", elTagType: "primary" },
  { label: "空间转录组(组织)", value: "11", elTagType: "primary" }
];

//  原始库用于筛选的字典
export const ORIGIN_SEND_ANALYSIS_TYPES_ALL = [
  { label: "组织", value: "1", elTagType: "primary" },
  { label: "核酸", value: "2", elTagType: "primary" },
  { label: "文库", value: "3", elTagType: "primary" },
  { label: "单细胞(组织)", value: "4", elTagType: "primary" },
  { label: "子文库", value: "5", elTagType: "primary" },
  { label: "单细胞|空间转录组(cDNA)", value: "10", elTagType: "primary" },
  { label: "空间转录组(组织)", value: "11", elTagType: "primary" }
];

//  用于筛选的字典
export const ORIGIN_SEND_ANALYSIS_TYPES = [
  { label: "组织", value: "1" }, //  原始样本
  { label: "核酸", value: "2" }, //  原始样本
  { label: "文库", value: "3" }, //  原始样本
  { label: "单细胞(组织)", value: "4" }, //  原始样本
  // { label: "子文库", value: "5" }, //  原始样本
  { label: "单细胞|空间转录组(cDNA)", value: "10" }, //  原始样本
  { label: "空间转录组(组织)", value: "11" } //  原始样本
];

//  全部的样本类型枚举
export const ORIGIN_SEND_ANALYSIS_ENUM = {
  "组织": "1",
  "核酸": "2",
  "文库": "3",
  "单细胞": "4",
  "子文库": "5",
  "交联产物样本": "6",
  "提取产物样本": "7",
  "建库产物样本": "8",
  "单细胞cDNA": "10",
  "空间转录组cDNA": "10-1",
  "空间转录组(组织)": "11",

  "1": "组织",
  "2": "核酸",
  "3": "文库",
  "4": "单细胞",
  "5": "子文库",
  "6": "交联产物样本",
  "7": "提取产物样本",
  "8": "建库产物样本",
  "10": "单细胞|空间转录组cDNA",
  "10-1": "空间转录组cDNA",
  "11": "空间转录组(组织)"
};
export const SAMPLE_TYPE_ENUM = ORIGIN_SEND_ANALYSIS_ENUM;

export const ORDER_USE_SAMPLE_TYPE = [
  { label: "组织", value: "1" },
  { label: "核酸", value: "2" },
  { label: "文库", value: "3" },
  { label: "单细胞(组织)", value: "4" },
  // { label: "子文库", value: "5" },
  // { label: "交联产物样本", value: "6" },
  // { label: "提取产物样本", value: "7" },
  // { label: "建库产物样本", value: "8" },
  { label: "单细胞(cDNA)", value: "10", cDnaType: "1" },
  { label: "空间转录组(cDNA)", value: "10-1", cDnaType: "2" },
  { label: "空间转录组(组织)", value: "11" }
];

//  产物样本库用于筛选的字典
export const PRODUCT_SEND_ANALYSIS_TYPES_ALL = [
  { label: "交联", value: "6", elTagType: "primary" },
  { label: "提取质检", value: "7", elTagType: "primary" },
  { label: "建库", value: "8", elTagType: "primary" }
];

//  sampleType与stage的对应关系
export const SAMPLE_TYPE_TO_STAGE = {
  6: "2",
  7: "3",
  8: "4"
};
//  sampleType与StageEnum的对应关系
export const SAMPLE_TYPE_TO_STAGE_ENUM = {
  6: "交联",
  7: "提取质检",
  8: "建库"
};

export const SAMPLE_PROGRESS_STATUS_MAP = {
  0: "未完成",
  1: "执行中",
  2: "已完成"
};

export const EXPERIMENT_STATUS = {
  0: "info",
  1: "primary",
  2: "success"
};

//  样本是否创建过实验单
export const HAS_THE_SAMPLE_BEEN_ORDERED = [
  { label: "是", value: 2, elTagType: "primary" },
  { label: "否", value: 1, elTagType: "primary" }
];
